import { render, staticRenderFns } from "./listado_especialistas.vue?vue&type=template&id=4e5149fc&scoped=true&"
import script from "./listado_especialistas.vue?vue&type=script&lang=js&"
export * from "./listado_especialistas.vue?vue&type=script&lang=js&"
import style0 from "./listado_especialistas.vue?vue&type=style&index=0&id=4e5149fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5149fc",
  null
  
)

export default component.exports